import axios from "axios";
import { toast } from "react-toastify";

const url = window.location.origin;
switch (url) {
    case "https://marjan.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer bWFyamFuOk1hcmphbkAxMjM0NTY=";//marjan
        axios.defaults.headers.get["Authorization"] = "Bearer bWFyamFuOk1hcmphbkAxMjM0NTY=";//marjan
        break;
    case "https://aratile.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer ZGVjb2Vhc2U6RGVjb2Vhc2VAMTIzfsh1";//aratile
        axios.defaults.headers.get["Authorization"] = "Bearer ZGVjb2Vhc2U6RGVjb2Vhc2VAMTIzfsh1";//aratile
        break;
    case "https://doroudian.ariisco.com":
        axios.defaults.headers.post["Authorization"] = "Bearer ZGVjb3sxfc2U6RGVjb2Vhc2VAMTIzfsh1";//doroudian
        axios.defaults.headers.get["Authorization"] = "Bearer ZGVjb3sxfc2U6RGVjb2Vhc2VAMTIzfsh1";//doroudian
        break;
    default:
        // axios.defaults.headers.post["Authorization"] = "Bearer ZW5naW5lOkVuZ2luZUAxMjM0NTY=wall";//ariis
        // axios.defaults.headers.get["Authorization"] = "Bearer ZW5naW5lOkVuZ2luZUAxMjM0NTY=wall";//ariis
        axios.defaults.headers.post["Authorization"] = "Bearer bWFyamFuOk1hcmphbkAxMjM0NTY=";//marjan
        axios.defaults.headers.get["Authorization"] = "Bearer bWFyamFuOk1hcmphbkAxMjM0NTY=";//marjan
        break;
}



axios.interceptors.response.use(null,error => {
    const exeptedError = error.response && error.response.status >= 400 && error.response.status < 500;
    if(!exeptedError){
        toast.error("مشکلی در سمت سرور رخ داده است!",{
            position:"bottom-right",
            autoClose:1500,
            closeButton:true,
            closeOnClick:true
        });
    };
    return Promise.reject(error);
});

export default {
    post:axios.post,
    get:axios.get,
    put:axios.put,
    delete:axios.delete
};